// extracted by mini-css-extract-plugin
module.exports = {"Modalli":"Modal_Modalli__1mk2C","Header":"Modal_Header__1ARDq","ModalTitle":"Modal_ModalTitle__20rvg"};